import {
  CorrespondenceEntityName,
  useCorrespondenceRouteWithUrlState,
  useCreateCorrespondenceThreadMutation,
  useMarkCorrespondencesAsReadMutation,
} from "toptaal-shared"
import { correspondenceQueryKeys } from "toptaal-shared"
import { getFilteredCorrespondence } from "toptaal-shared"
import {
  createFileRoute,
  useNavigate,
  useParams,
  useRouter,
  useSearch,
} from "@tanstack/react-router"
import {
  CorrespondenceEntityType,
  CorrespondenceOverview,
  CorrespondenceThread,
  createTableSearchSchema,
} from "toptaal-shared"
import { can } from "@/utils/can"
import { checkPermissions } from "@/utils/checkPermissions"
import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import { useGroupSuspenseQuery } from "@/api/queries/groups/useGroupSuspenseQuery"

export const Route = createFileRoute(
  "/beheer/groepen/$groupId/correspondentie/",
)({
  component: RouteComponent,
  validateSearch: createTableSearchSchema(),
  beforeLoad: async () => {
    return checkPermissions("read", "groupCorrespondence")
  },
})

function RouteComponent() {
  const { groupId } = useParams({
    from: "/beheer/groepen/$groupId/correspondentie/",
  })
  const searchParams = useSearch({
    from: "/beheer/groepen/$groupId/correspondentie/",
  })
  const navigate = useNavigate({
    from: "/beheer/groepen/$groupId/correspondentie/",
  })

  const router = useRouter()
  const { data: user } = useCurrentUserSuspenseQuery()
  const { data: group } = useGroupSuspenseQuery({
    groupId: Number(groupId),
  })
  const entityType: CorrespondenceEntityType = "LessonGroup"
  const entityId = Number(groupId)
  const entityName: CorrespondenceEntityName = String(group.data.id)

  const correspondenceProps = useCorrespondenceRouteWithUrlState({
    entityType,
    entityId,
    queryKey: correspondenceQueryKeys.group(entityId, entityType),
    queryFn: (filters) =>
      getFilteredCorrespondence({ entityId, entityType, filters }),
    useCreateMutation: useCreateCorrespondenceThreadMutation,
    searchParams,
    navigate,
    storageKey: `/beheer/groepen/${groupId}/correspondentie`,
  })

  const markAsReadMutation = useMarkCorrespondencesAsReadMutation({
    queryKey: correspondenceQueryKeys.group(entityId, entityType),
  })

  const handleNavigateToThread = (thread: CorrespondenceThread) => {
    if (thread.unreadCount > 0) {
      markAsReadMutation.mutate([thread.id])
    }

    router.navigate({
      to: "/beheer/groepen/$groupId/correspondentie/$threadId",
      replace: true,
      params: {
        threadId: String(thread.id),
        groupId,
      },
    })
  }

  return (
    <CorrespondenceOverview
      {...correspondenceProps}
      handleNavigateToThread={handleNavigateToThread}
      contextType={entityType}
      entityName={entityName}
      canCreateCorrespondence={can("create", "groupCorrespondence")}
      correspondencePermission={{
        root: "mtt",
        roles: user.data.roles,
        baseUserId: user.data.baseUserId,
      }}
    />
  )
}
